export const CONSENT_STORAGE_KEY = 'consent-v1'

/** Dispatched on `window` after consent is saved (same tab). */
export const ANALYTICS_CONSENT_CHANGED_EVENT = 'analytics-consent-changed'

export type StoredConsent = {
  analytics: boolean
  ads: boolean
  ts: number
}

export function loadStoredConsent(): StoredConsent | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY)
    return raw ? (JSON.parse(raw) as StoredConsent) : null
  } catch {
    return null
  }
}

export function saveStoredConsent(consent: StoredConsent): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent))
  } catch {
    // storage may be disabled; consent will reprompt next visit
  }
}
